<template>
    <section class="resume-section summary-section mb-5">
        <h2 class="resume-section-title text-uppercase font-weight-bold pb-3 mb-3">{{career.title}}</h2>
        <div class="resume-section-content" v-html="career.html"></div>
    </section>
</template>
<script>
    export default {
        name: "Career",
        computed: {
            career() {
                return this.$store.state.career[this.$store.state.config.lang].section;
            }
        }
    }
</script>